export const VERIFICATION_TYPES = {
  registration: 'registration',
  forgot_password: 'forgot_password',
  delete_account: 'delete_account',
  profile: 'profile',
};

export const CLIENT_EXTERNAL_TYPES = {
  google: 'google',
  microsoft: 'microsoft',
};
